"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/asyncToGenerator"));

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

var _admin = require("@/api/admin");

var _log = require("@/api/log");

var _AIAgent = _interopRequireDefault(require("@/components/AIAgent"));

var _cti = require("@/api/cti");

var _customer = require("@/api/customer");

var _date = require("@/utils/date");

var _moment = _interopRequireDefault(require("moment"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "cti",
  components: {
    AiAgent: _AIAgent.default
  },
  filters: {
    durationFilter: function durationFilter(value) {
      if (value == null) return "00:00:00";
      var h = parseInt(value / 3600);
      var m = parseInt(value % 3600 / 60);
      var s = parseInt(value % 3600 % 60);
      h = h.toString().length < 2 ? "0" + h.toString() : h.toString();
      m = m.toString().length < 2 ? "0" + m.toString() : m.toString();
      s = s.toString().length < 2 ? "0" + s.toString() : s.toString();
      return h + ":" + m + ":" + s;
    }
  },
  props: {
    gapWidth: {
      type: Number,
      default: 10
    }
  },
  mounted: function mounted() {
    this.timer = setInterval(this.handleTimer, 1000);
  },
  computed: {
    user: function user() {
      return this.$store.state.user;
    }
  },
  created: function created() {
    this.left = (document.documentElement.clientWidth - 720 - 20) / 2;
    this.top = 1; // this.clientHeight*this.coefficientHeight;
    //获取所有分机

    this.getExtList(); //开始注册cti

    this.handle_Cti_Login(); //初始化当天的小休等信息

    var _idletime = localStorage.getItem(this.idleName);

    if (_idletime && _idletime != 'undefined') this.ctiRest = JSON.parse(_idletime);

    if (this.ctiRest) {
      this.ctiRest = {
        title: "小休",
        icon: "call-rest",
        type: '',
        //本次小休类型
        start: undefined,
        //本次小休开始事件
        duration: 0,
        //本次小休时长
        meeting: 0,
        //累计
        AtLunch: 0,
        DoNotdisturb: 0,
        ACW: 0
      };
    }
  },
  data: function data() {
    return {
      idleName: "idletime" + (0, _moment.default)(new Date()).format("YYYY-MM-DD"),
      //小休信息缓存值名称
      timer: null,
      left: 0,
      top: 0,
      userInfo: {},
      //坐席
      userExtList: [],
      //可转分机信息
      ctiRest: {
        title: "小休",
        icon: "call-rest",
        type: '',
        //本次小休类型
        start: undefined,
        //本次小休开始事件
        duration: 0,
        //本次小休时长
        meeting: 0,
        //累计
        AtLunch: 0,
        DoNotdisturb: 0,
        ACW: 0
      },
      call: {
        tranferStatus: '',
        //是否点击了确认转接 dial:拨号 ring:响铃 connceted:对方接起
        tranferNo: '',
        //转接分机号
        isHold: '',
        //外呼电话内容 source:ib campaign ticket toolbar
        callId: '',
        //电话cic的callid
        builtId: 0,
        customerId: 0,
        mobile: "",
        name: "",
        type: "callout",
        //ob ib
        source: "",
        connected: 0,
        ringingtime: 0,
        talktime: 0,
        callCusId: '' //通过toolbar外呼的客户 如果不点击弹屏 这个没用的

      },
      status_login: false,
      //是否登录成功
      showDialOutBtn: false,
      //是否展示外拨框
      isManuChangeOb: false,
      //是否为手动修改ob状态 如果是允许调整title上的内容
      statusTxt: "未登录",
      //通话状态:拨打、响铃中、通话中、通话保持
      statusCti: '',
      //未翻译的cti的状态：OB、小休、ACW、空闲等
      status_icon: "call-signout",
      //状态栏图标
      timer_status: false,
      //timer计数器状态 true计数 false停止
      timer_num: 0,
      //状态栏计数器的数值
      title: "未设置分机号，登录失败",
      //状态栏显示内容
      cicEvent: '',
      //当前点击的事件
      records: [],
      //通话录音
      resetStatus: [''],
      restoreStatus: false //是否需要恢复通话工具条

    };
  },
  methods: {
    handle_Cti_Login: function handle_Cti_Login() {
      var _this = this;

      console.log('handle_Cti_Login', this.status_login);
      if (this.status_login) return; //将被动函数委托给global

      cicGlobal.startOBTask = this.startOBTask;
      cicGlobal.saveOBTask = this.saveOBTask;
      cicGlobal.callBackEvent = this.handleCallBackEvent;
      cicGlobal.showMsg = this.showMsg; //获取分机并注册

      (0, _admin.readAdmin)().then(function (res) {
        _this.userInfo = res.data.data;

        if (_this.userInfo.extNo) {
          _this.title = "话机注册中";
          _this.timer_status = true;
          cicGlobal.extNo = _this.userInfo.extNo;
          cicGlobal.agentId = _this.userInfo.qiYu;
          cicGlobal.pwd = _this.userInfo.extPwd;
          cicGlobal.wsLogin();
        }
      });
    },

    /**
     * 业务事件 ob客服开始处理电访中心的任务
     */
    startOBTask: function startOBTask() {
      console.log('startOBTask');
      this.handleCallReset(null);
      this.call.customerId = this.$store.state.panel.customerId;
      this.call.mobile = this.$store.state.panel.built.callMobile;
      this.call.callType = "callout";
      this.call.source = "campaign";
      this.call.builtId = this.$store.state.panel.builtId;
      this.call.campaignId = this.$store.state.panel.campaignId; //判断是否符合外拨
      //if (this.validDialOut(this.call.mobile) == false) return;
      //开始外拨 (延迟2秒) ---取消自动外拨
      // setTimeout(() => {
      //   cicGlobal.makeDial(this.call.mobile);
      //   this.handleStatus("呼叫中", this.call.mobile);
      // }, 2000);
    },
    saveOBTask: function saveOBTask(calllogId) {
      this.handleUpdateRecord(calllogId);
      this.handleCallReset();
    },

    /**
     * 统一调用cic外拨
     * 工具条输入手机号外拨
     * @param {方法名} event
     */
    callCicEvent: function callCicEvent(event, value) {
      var _this2 = this;

      console.info('cti event', event);
      this.cicEvent = event;

      if (event == "dialOut") {
        var mobile = this.call.mobile;
        if (this.validDialOut(this.call.mobile) == false) return; //重置下参数
        //如果是ob电访期间的外拨 记录builtId,customerId
        // let builtId = this.call.builtId;
        // let cusId = this.call.customerId;

        this.handleCallReset(null);
        this.call.source = "toolbar"; //工具条外呼

        this.call.callType = "callout";
        this.call.mobile = mobile; // if (builtId && builtId > 0) {
        //   this.call.builtId = builtId
        //   this.call.customerId = cusId
        // }
        //开始外拨

        if (cicGlobal.makeDial(this.call.mobile)) this.handleStatus("呼叫中", this.call.mobile);
      } else if (event == 'hangup') {
        cicGlobal.hangup(this.call.callId);
        this.handleStatus("ACW", null); //防止意外情况 这里强制acw状态
      } else if (event == 'changeStatus') {
        if (value == "callout") this.isManuChangeOb = true;
        cicGlobal.changeStatus(value);
      } else if (event == "hold") {
        this.call.tranferStatus = ''; //防止转接进入保留

        cicGlobal.holdByCallId(this.call.callId);
      } else if (event == "unhold") cicGlobal.releaseHoldByCallId(this.call.callId);else if (event == "accept") cicGlobal.accept(this.call.callId);else if (event == "tranfer") {
        //2步转处理 首先拨待转电话 然后再转过去
        if (value) {
          //输入待转接的分机号后
          this.call.tranferNo = value;
          cicGlobal.conferenceTranfer(value);
        }
      } else if (event == 'tranferOk') {
        cicGlobal.conferenceTranferOk(this.call.callId);
      } else if (event == 'tranferCancel') {
        cicGlobal.conferenceTranferCancel(this.call.callId, this.call.consultId);
      } else if (event == 'tranferIvr') {
        //转ivr
        cicGlobal.tranferIvr(this.call.callId); //转满意度时 有时不会有挂断事件 直接是OB 这里手动调用

        this.handleStatus("ACW");
      } else if (event == 'addTicket') {
        this.$nextTick(function () {
          _this2.$router.push({
            path: '/ib/addWorkOrder/' + _this2.call.callCusId + '/0',
            query: {
              title: '[' + _this2.call.mobile + ']工单',
              callrecordId: _this2.call.callrecordId
            }
          });
        });
      }
    },
    handleStatus: function handleStatus(_status, _title) {
      var _this3 = this;

      //默认不展示外拨框
      this.showDialOutBtn = false; //Available、ACW、OB、At a Training、At a training session表示话机状态 其他如通话 表是一通电话状态

      if (_status == "free" || _status == "after" || _status == "callout" || _status == "break" || _status == "training" || _status == "meal" || _status == "meeting" || _status == "Do Not disturb") {
        this.status_icon = "call-locked";
        this.timer_num = 0;

        if (_status == "free") {
          this.title = "话机空闲";
          this.ctiRest.icon = "call-ready";
          this.ctiRest.title = "空闲";
          this.statusTxt = "空闲"; // this.ctiRest.icon = "call-rest";

          this.call.city = '';
          this.call.tranferStatus = '';
          this.showDialOutBtn = true;
          this.timer_num = 0;
        } else if (_status == "training" || _status == "meeting") {
          this.ctiRest.title = "培训";
          this.ctiRest.icon = "call-ready";
          this.statusTxt = "小休";
          this.title = "培训中";
          this.timer_num = this.ctiRest.meeting;
        } else if (_status == "meal") {
          this.ctiRest.title = "午餐";
          this.ctiRest.icon = "call-ready";
          this.statusTxt = "小休";
          this.title = "午餐";
          this.timer_num = this.ctiRest.AtLunch;
        } else if (_status == "break") {
          this.ctiRest.title = "小休";
          this.ctiRest.icon = "call-ready";
          this.statusTxt = "小休";
          this.title = "请勿打扰";
          this.timer_num = this.ctiRest.DoNotdisturb;
        } else if (_status == "callout") {
          //属于话机技能状态 不修改status值
          this.title = "话机外拨";
          this.showDialOutBtn = true;
          this.ctiRest.title = "外拨...";
          this.ctiRest.icon = "call-out";
          this.statusTxt = 'callout';
          this.timer_num = 0;
        } else if (_status == "after") {
          this.title = "话后中，请尽快完成并切换状态";
          this.ctiRest.title = "ACW";
          this.statusCti = "after";
          this.statusTxt = '话后';
          this.timer_num = this.ctiRest.ACW;
          this.call.tranferStatus = '';
          this.ctiRest.icon = "call-acw";
        }

        this.ctiRest.type = _status;
        this.ctiRest.duration = 0;
        this.ctiRest.start = new Date();
      } else if (_status == "呼叫中") {
        this.title = "呼叫中:" + this.call.mobile;
        this.timer_num = 0;
        this.statusTxt = _status;
        this.status_icon = "call-out";
      } else if (_status == "响铃中") {
        this.title = _title;
        this.timer_num = 0;
        this.statusTxt = _status;
        this.status_icon = "call-ringing"; //获取归属地

        (0, _customer.findCityByMobile)(this.call.mobile).then(function (res) {
          _this3.call.city = '归属地-' + res.data.data.province + res.data.data.city;
        }).catch(function (err) {
          _this3.call.city = '';
        }); //这里主动弹屏

        this.handleShowPanel(this.call.callType);
      } else if (_status == "通话中") {
        this.title = "通话中:" + this.call.mobile;
        this.timer_num = 0;
        this.statusTxt = _status;
        this.status_icon = "call-talking";
      } else if (_status == "转接中") {
        this.title = "转接中:" + this.call.tranferNo;
        this.statusTxt = _status;
        this.status_icon = "call_tran";
      } else if (_status == "转接响铃中") {
        this.call.tranferStatus = "ring";
      } else if (_status == "转接接通中") {
        this.call.tranferStatus = "connected";
      } else if (_status == "保留中") {
        this.statusTxt = "保留中";
        this.status_icon = "call-hold";
        this.title = "通话保留中:" + this.call.mobile;
      } else if (_status == "保留恢复") {
        this.statusTxt = "通话中";
        this.status_icon = "call-talking";
        this.title = "通话中:" + this.call.mobile;
        this.call.tranferNo = null;
      } else if (_status == "unregister") {
        this.statusTxt = "未登录";
        this.title = "注册失败点击图标重新登录";
        this.status_icon = "call-signout";
        this.status_login = false;
      } else if (_status == 'AcdAgentNotAnswering') {
        //无应答
        cicGlobal.hangup(this.call.callId);
      } //重新计时开始


      this.handleTimer(); //变更全局状态

      cicGlobal.ctiStatus = this.statusTxt;
      console.info('handleStatus参', '入_status=' + _status, '出statusTxt=' + this.statusTxt, ' status_login=' + this.status_login, _title);
    },

    /**
     * 响铃中时的状态 处理弹框
     * IB 必弹屏
     * OB 分任务和toolbar点击
     */
    handleShowPanel: function handleShowPanel() {
      var _this4 = this;

      if (this.call.callType == 'IB') {
        //进电
        (0, _customer.findOrAdd)(this.call.mobile).then(function (res) {
          _this4.call.customerId = res.data.data;
          _this4.call.callCusId = res.data.data; //进电时 将次id重置成一致
          //保存话务记录

          _this4.handleCreateRecord(null).then(function (res) {
            console.info('callrecord id1', _this4.call.callrecordId);

            _this4.$nextTick(function () {
              _this4.$router.push({
                path: '/ib/addWorkOrder/' + _this4.call.customerId + '/0',
                query: {
                  title: '[' + _this4.call.mobile + ']工单',
                  callrecordId: _this4.call.callrecordId,
                  source: 'IB'
                }
              });
            });
          });
        });
      } else {
        //工具栏输入外呼 || 点击客户信息外拨
        //ob任务外呼 直接记录外呼话务记录
        if (this.call.builtId && this.call.builtId > 0) {
          console.info("任务外拨,id=" + this.call.builtId + "拦截弹屏");
          this.handleCreateRecord(this.call.customerId);
          return;
        } //任务栏输入


        (0, _customer.findOrAdd)(this.call.mobile).then(function (res) {
          _this4.call.callCusId = res.data.data; //只保存话务记录

          _this4.handleCreateRecord(res.data.data).then(function (res) {
            console.info('callrecord id1', _this4.call.callrecordId); //没有载入任务 直接外拨

            if (_this4.user.userType == 1) {
              console.info("没有载入任务或工具栏点击外拨 OB角色,只记录日志");
              return;
            }

            _this4.$nextTick(function () {
              _this4.$router.push({
                path: '/ib/addWorkOrder/' + _this4.call.callCusId + '/0',
                query: {
                  title: '[' + _this4.call.mobile + ']工单',
                  callrecordId: _this4.call.callrecordId,
                  source: 'OB'
                }
              });
            });
          });
        });
      }
    },
    handleCreateRecord: function () {
      var _handleCreateRecord = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cusId) {
        var _this5 = this;

        var param;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //新增话务记录
                param = {
                  mobile: this.call.mobile,
                  cusId: cusId ? cusId : this.call.customerId,
                  callType: this.call.callType,
                  callSource: this.call.source ? this.call.source : 'click',
                  callId: this.call.callId,
                  builtId: this.call.builtId,
                  campaignId: this.call.campaignId
                };
                _context.next = 3;
                return (0, _cti.createCallRecord)(param).then(function (res) {
                  if (res.data.errno == 0) {
                    _this5.call.callrecordId = res.data.data;

                    _this5.records.push(param); //赋值到缓存


                    //赋值到缓存
                    _this5.$store.commit("setCallId", {
                      callId: _this5.call.callrecordId
                    });
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleCreateRecord(_x) {
        return _handleCreateRecord.apply(this, arguments);
      }

      return handleCreateRecord;
    }(),
    handleUpdateRecord: function handleUpdateRecord(calllogId) {
      //如果传了calllogId表示从外层进来的事件 需要重置所有对象
      if (calllogId && this.records.length > 0) {
        var param = {
          calllogId: calllogId,
          callId: this.records.map(function (item) {
            return item.callId;
          })
        };
        console.info('updateCallRecords', param);
        (0, _cti.updateCallRecords)(param);
        this.records = [];
      } else {
        //单条更新
        var _param = {
          callId: this.call.callId,
          connected: this.call.connected,
          talktime: this.call.talktime,
          ringingtime: this.call.ringingtime
        };
        (0, _cti.updateCallRecord)(_param);
      }
    },
    handleSaveUserRest: function handleSaveUserRest() {
      var _this6 = this;

      //保存小休
      if (this.ctiRest.type == 'ACW' || this.ctiRest.duration == 0 || this.statusTxt == '小休') return;
      var data = {
        restType: this.ctiRest.type,
        duration: this.ctiRest.duration,
        startTime: (0, _date.formatDate)(this.ctiRest.start, "yyyy-MM-dd hh:mm:ss"),
        endTime: (0, _date.formatDate)(new Date(), "yyyy-MM-dd hh:mm:ss")
      };
      (0, _cti.createRest)(data).then(function (res) {
        _this6.ctiRest.duration = 0;
      });
    },

    /**
     * 重置call对象
     * @param {calllog表外键} calllogId
     */
    handleCallReset: function handleCallReset() {
      //新通话 仅初始化call对象
      this.call = {
        tranferStatus: '',
        tranferNo: '',
        isHold: '',
        //是否保持
        callId: 0,
        connected: false,
        ringingtime: 0,
        talktime: 0,
        builtId: 0,
        customerId: 0,
        mobile: '',
        name: "",
        type: "callout",
        source: ""
      };
      this.cicEvent = "";
    },
    handleTimer: function handleTimer() {
      if (this.timer_status) {
        this.timer_num++; //console.info(this.title_timer)

        if (this.statusTxt == "响铃中") this.call.ringingtime = this.timer_num;else if (this.statusTxt == "通话中") this.call.talktime = this.timer_num;else if (this.statusTxt == "小休") {
          this.ctiRest.duration = this.timer_num;
          if (this.ctiRest.type == "training") this.ctiRest.meeting++;else if (this.ctiRest.type == "break") this.ctiRest.DoNotdisturb++;else if (this.ctiRest.type == "meal") this.ctiRest.AtLunch++;else if (this.ctiRest.type == "after") this.ctiRest.ACW++;
          if (this.timer_num % 10 == 0) localStorage.setItem(this.idleName, JSON.stringify(this.ctiRest));
        }
      }
    },
    handleCallBackEvent: function handleCallBackEvent(data) {
      //处理cic服务器的消息
      //处理状态
      if (data.status) {
        if (data.status == 'disconnect') {
          (0, _log.createCtiLog)('disconnect', '断开链接', data.name);
          this.status_login = false;
          this.title = "话机断联" + data.name + "，刷新重登";
          this.statusTxt = '未登录';
        } // else if (this.status_login == false)//重连时的状态重置
        //   this.status_login = true;


        if (data.status == 'store_session') {
          //表示重连 需要重置状态
          console.info('store_session 重连已完成');
          this.status_login = true;
          this.title = "话机空闲";
          this.statusTxt = '空闲';

          if (data.currentCall) {
            this.restoreStatus = true;
            this.saveCallInfo(JSON.stringify(data.currentCall)); //保存进电信息 用来重连时的状态复原
          }
        }

        if (data.status == 'success') {
          //签入成功（注册成功）
          (0, _log.createCtiLog)('login', '登录成功');
          this.status_login = true;
          this.title = "话机空闲";
          this.statusTxt = '空闲'; // if (this.user.userType == 1) //外呼组 直接进入ob状态
          //   this.callCicEvent("changeStatus", "OB");
          // else
          //   this.callCicEvent("changeStatus", "free");

          this.callCicEvent("changeStatus", "break");
          data.status = 'break';
        } else if (data.status == 'consult_fail') {
          //磋商失败 需要取回
          this.callCicEvent('tranferCancel', null);
          this.call.tranferStatus = 'cancel';
        } else if (data.status == 'consult_inbound_hangup') {
          //磋商中来电方挂断
          this.callCicEvent('hangup', null);
          this.call.tranferStatus = 'cancel';
        } else if (data.status == 'consult_conference') {
          //磋商三方通话成功--直接挂断
          this.callCicEvent('hangup', null); // this.call.tranferStatus = 'talking';
          // this.handleStatus("转接通话中", "转接通话中:" + this.call.tranferNo);
        } else if (data.status == 'consult') {
          //发起磋商成功
          this.call.tranferStatus = 'connected';
          this.handleStatus("转接中", "转接中:" + this.call.tranferNo);
        } else if (data.status == 'incall') {
          //用来处理incall状态恢复
          console.log('restoreStatus', this.restoreStatus);
          if (!this.restoreStatus) return; //没有刷新页面 不处理状态还原

          var _data = this.getCallInfo();

          if (_data) data = JSON.parse(_data); //如果是呼入 creater=='answered' 兼容范围类型不一致问题

          if (data.creater && data.creater == 'answered') data.name = 'CHANNEL_ANSWER';
          console.log(data);
          this.restoreStatus = false;
        } //处理状态事件-- 兼容处理小休状态


        if (data.status == 'rest' || data.status == "free" || data.status == "after" || data.status == "callout" || data.status == "break" || data.status == "training" || data.status == "meal" || data.status == "meeting") {
          if (!this.status_login) this.status_login = true;
          if (data.status == 'rest' && !data.restReason) //转换下小休状态
            data.status = 'break';
          this.handleStatus(data.status == 'rest' ? data.restReason : data.status, '');
        }
      } //记录服务器日志


      (0, _log.createCtiLog)(this.statusTxt, data.name ? data.name : data.status, JSON.stringify(data)); //拨号&进电振铃

      if (data.name == "CHANNEL_CREATE") {
        this.handleCallReset(null);
        this.call.mobile = data.direction == "out" ? data.discalled : data.discaller;
        this.call.callId = data.id;
        this.call.callType = data.direction == "out" ? 'OB' : 'IB';
        this.handleStatus("响铃中", "响铃中:" + this.call.mobile);
      } //拨号接听--外拨接听


      if (data.name == "CHANNEL_ANSWER") {
        if (!this.call.mobile) {
          this.call.mobile = data.direction == "out" ? data.discalled : data.discaller;
          this.call.callId = data.id;
          this.call.callType = data.direction == "out" ? 'OB' : 'IB';
        }

        this.handleStatus("通话中", "通话中:" + this.call.mobile);
        this.call.connected = true; //接通

        this.handleUpdateRecord();
      } //挂断


      if (data.name == "CHANNEL_HANGUP_COMPLETE") {
        //挂断--直接进入acw
        if (this.user.userType == 0 || this.statusCti == 'free') //ib客服 通话结束后 有个话后处理时间 ob不用
          cicGlobal.changeStatus("after");else this.handleStatus("after", null);
        this.showMsg("挂断原因：" + data.hangupcase); //更新通话信息

        this.handleUpdateRecord();
      } //保持


      if (data.name == "CHANNEL_HOLD") {
        //协议转时 会将原通话保持中 判断是协议转 不进入保持
        this.call.isHold = true;
        this.handleStatus("保留中", null);
      } //保持恢复


      if (data.name == "CHANNEL_UNHOLD") {
        this.call.isHold = false;
        this.call.tranferStatus = '';
        this.handleStatus("保留恢复", "通话中:" + this.call.mobile);
      }
    },

    /**
     * 验证是否可以外拨
     */
    validDialOut: function validDialOut(mobile) {
      if (this.status_login == false) {
        // this.$notify.error({
        //   title: "提醒",
        //   message: "话机未登录，无法外拨",
        //   customClass: 'notify-on-top'
        // });
        this.title = "话机未登录，无法外拨";
        return false;
      }

      if (mobile == null || mobile.length < 8) {
        // this.$notify.error({
        //   title: "提醒",
        //   message: "请输入正确的电话号码",
        //   customClass: 'notify-on-top'
        // });
        this.title = "请输入正确的电话号码";
        return false;
      }

      return true;
    },
    getExtList: function getExtList() {
      var _this7 = this;

      (0, _admin.getExtList)().then(function (res) {
        _this7.userExtList = res.data.data;
      });
    },
    showMsg: function showMsg(msg) {
      this.$notify.warning({
        title: '提醒',
        message: msg,
        customClass: 'notify-on-top'
      });
    },
    saveCallInfo: function saveCallInfo(_data) {
      try {
        sessionStorage.setItem('cti_call_info', _data);
      } catch (e) {}
    },
    getCallInfo: function getCallInfo() {
      try {
        return sessionStorage.getItem('cti_call_info');
      } catch (e) {
        return null;
      }
    }
  }
};
exports.default = _default;